module.exports = __webpack_public_path__ + "static/flags/CO-e335ed3f1f32dc423233334d9da2322f.gif";